module.exports = __webpack_public_path__ + "img/laptop-computers-1236114-1919x1112.237c4806.jpg";